const Themes = [{
  key: 'lyster',
  title: 'Lyster',
  flavor: 'light',
  family: 'lyster',
  colors: {
    primary: '#ffa601', // primary: 'green',
    primaryText: '#ffffff',

    secondary: '#ff5601',
    secondaryText: '#eeeeee',

    background: '#eeeeee',
    surface: '#ffffff',
    separator: '#cccccc',
    text: '#111111',

    delete: '#ff3010',
    postpone: '#ff7542',
    list: '#ffc700',
    done: '#406800',
  },
  icons: {
    delete: { name: 'delete' },
    postpone: { name: 'access-time' },
    list: { name: 'list' },
    done: { name: 'check' },
  },
  // eslint-disable-next-line global-require
  // backgroundImage: require('../../images/cappuccino.jpeg'),
}, {
  key: 'lyster-dark',
  title: 'Lyster Dark',
  isDark: true,
  flavor: 'dark',
  family: 'lyster',
  colors: {
    primary: '#ffa601', // primary: 'green',
    primaryText: '#000000',

    secondary: '#ff5601',
    secondaryText: '#111111',

    background: '#221101',
    surface: '#442202',
    separator: '#553313',
    text: '#cccccc',

    delete: '#ff3010',
    postpone: '#ff7542',
    list: '#ffc700',
    done: '#406800',
  },
  icons: {
    delete: { name: 'delete' },
    postpone: { name: 'access-time' },
    list: { name: 'list' },
    done: { name: 'check' },
  },
  // eslint-disable-next-line global-require
  // backgroundImage: require('../../images/cappuccino.jpeg'),
}, {
  key: 'green-goblin',
  title: 'Green Goblin',
  flavor: 'light',
  family: 'green',
  colors: {
    primary: '#449944', // primary: 'green',
    primaryText: '#111111',

    secondary: '#006600',
    secondaryText: '#cccccc',

    background: '#eeeeee',
    surface: '#ffffff',
    separator: '#cccccc',
    text: '#111111',

    delete: '#ff3010',
    postpone: '#ff7542',
    list: '#ffc700',
    done: '#406800',
  },
  icons: {
    delete: { name: 'delete' },
    postpone: { name: 'access-time' },
    list: { name: 'list' },
    done: { name: 'check' },
  },
  // eslint-disable-next-line global-require
  // backgroundImage: require('../../images/cappuccino.jpeg'),

}, {

  key: 'dark-forest',
  title: 'Dark Forest',
  isDark: true,
  family: 'green',
  flavor: 'dark',
  colors: {
    primary: '#226622', // primary: 'green',
    primaryText: '#eeffee',

    secondary: '#114411',
    secondaryText: '#cceecc',

    background: '#006600',
    surface: '#449944',
    separator: '#77CC77',
    text: '#ddffdd',

    delete: '#ff3010',
    postpone: '#ff7542',
    list: '#ffc700',
    done: '#406800',
  },
  icons: {
    delete: { name: 'delete' },
    postpone: { name: 'access-time' },
    list: { name: 'list' },
    done: { name: 'check' },
  },
  // eslint-disable-next-line global-require
  // backgroundImage: require('../../images/cappuccino.jpeg'),

}, {
  key: 'full-moon',
  title: 'Full Moon',
  isDark: false,
  family: 'moon',
  flavor: 'light',
  colors: {
    primary: '#aaaaff', // primary: 'green',
    primaryText: '#000033',

    secondary: '#663366',
    secondaryText: '#ccccff',

    background: '#eeeeff',
    surface: '#ddddff',
    separator: '#ccccee',
    text: '#111122',

    delete: '#ff3010',
    postpone: '#ff7542',
    list: '#ffc700',
    done: '#406800',
  },
  icons: {
    delete: { name: 'delete' },
    postpone: { name: 'access-time' },
    list: { name: 'list' },
    done: { name: 'check' },
  },
  // eslint-disable-next-line global-require
  // backgroundImage: require('../../images/cappuccino.jpeg'),
}, {
  key: 'dark-moon',
  title: 'Dark Moon',
  isDark: true,
  family: 'moon',
  flavor: 'dark',
  colors: {
    primary: '#000033',
    primaryText: '#eeeeee',

    secondary: '#663366',
    secondaryText: '#ccccff',

    background: '#333377',
    surface: '#6666AA',
    separator: '#555588',
    text: '#eeeeee',

    delete: '#ff3010',
    postpone: '#ff7542',
    list: '#ffc700',
    done: '#406800',
  },
  icons: {
    delete: { name: 'delete' },
    postpone: { name: 'access-time' },
    list: { name: 'list' },
    done: { name: 'check' },
  },
  // eslint-disable-next-line global-require
  // backgroundImage: require('../../images/cappuccino.jpeg'),
}];

export default Themes;
